import './styles/CheckSlide.scss';
import type { ChangeEvent } from "react";

type Props = {
  id: string;
  label: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
};

const CLASS_PREFIX = `ws-widgets-check-slide`;

const CheckSlide = ({ id, label, checked, onChange }: Props) => (
  <div className={ `${ CLASS_PREFIX }` }>
    <label
      className={ `${ CLASS_PREFIX }__label` }
      htmlFor={ id }
    >
      { label }
    </label>
    <input
      type="checkbox"
      id={ id }
      checked={ checked }
      className={ `${ CLASS_PREFIX }__input` }
      onChange={ onChange }
    />
    <label
      className={ `${ CLASS_PREFIX }__button` }
      htmlFor={ id }
    ></label>
  </div>
);

export default CheckSlide;
